import React from 'react';
import { H3 } from 'scy/text';
import margin from 'scy/margin.mod.scss';

export default function LoginHeader() {
  return (
    <H3 tag="h1" marginClass={`${margin.top_0} ${margin.bottom_sm}`}>
      Hey stranger, welcome back
    </H3>
  );
}
